@for (safetyTagData of safetyHints | async; track safetyTagData; let hintIndex = $index) {
    @if (hintIndex <= lastSafetyHintsConfirmed) {
        <ecs-safety-hint-tag
            [safetyHint]="safetyTagData"
            [dialogOpen]="hintIndex >= lastSafetyHintsConfirmed"
            (hintConfirmEvent)="setLastSafetyHintConfirmed(hintIndex + 1)"
        >
        </ecs-safety-hint-tag>
    }
}
